import type { Settings } from '../types';

export const DEFAULT_SETTINGS: Settings = {
    backgroundColor: '#000000',
    enableAds: false,
    enableGooglePal: false,
    enableHideAdUiElements: false,
    enablePauseAds: false,
    enablePauseAdsLoopMode: false,
    enableOmSdk: false,
    enableWhyThisAdIcon: false,
    enhancedMetadataViews: false,
    liveEndpoint: 'V4',
    persistTextTrackSelection: false,
    muxEnvironmentKey: process.env.REACT_APP_ENVIRONMENT === 'production' ? 'c603cae0cab019beb85f1c4c3' : '4004c26186c29919e27fa9f6c',
    preferDash: false,
    progressColor: '#FFFFFF',
    textColor: '#FFFFFF',
    videoEndpoint: 'V4'
};
